import React, { useState } from "react";
import "./ClientAcademiesTab.css";
import { ClientAcademiesTabData } from "./ClientAcademiesTabData.jsx";

function ClientAcademiesTab() {
  return (
    <>
      <div className="box-container client-academies-container">
        <div className="cube-box-wrap">
          {ClientAcademiesTabData.map((item) => {
            return (
              <div key={item.id} className="cube-box-row">
                <div className="box-shadow top"></div>
                <div className="box-shadow left"></div>
                <div
                  className="main-box1"
                  style={{ backgroundImage: `url(${item.img_url})` }}
                >
                  <a href={item.portal_url}>
                    <div className="flip-content">
                      <h4>{item.portal_content}</h4>
                      <div
                        className="points-box"
                        dangerouslySetInnerHTML={{
                          __html: item.portal_content_points,
                        }}
                      ></div>
                      <p>View more...</p>
                    </div>
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default ClientAcademiesTab;
